import { ErrorHandler, Injectable } from '@angular/core'
import { GlobalMessagingSeverityConstants } from 'app/shared/generated/generated'
import { MessageBusService } from 'app/shared/services/message-bus.service'
import { HandledError } from './../../shared/models/handled-error'
import { AppConfigService } from './../../shared/services/app-config.service'

@Injectable()
export class ClientErrorHandler implements ErrorHandler {
  constructor(private messageBusService: MessageBusService, private appConfigService: AppConfigService) {}

  handleError(error: any) {
    if (this.appConfigService.areDetailedErrorsEnabled()) {
      if (!(error instanceof HandledError)) {
        let errorMessage = `${error.message} <ul class='mt-5 text-left'><li>At ${
          window.location
        }</li><li>On ${new Date().toLocaleTimeString()}</li><li>In ClientErrorHandler</li></ul>`

        this.messageBusService.addNotification(
          this.messageBusService.createMessage(
            GlobalMessagingSeverityConstants.error,
            '😈 <b>JS</b> Dev Annoyer 😈',
            errorMessage
          )
        )
      }
    }
    console.error(error)
  }
}
